import { PawPrint, Cigarette, HeartOff } from "lucide-react";

const chip = "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold";

export function ClientFlags({ c, detailed = false }) {
  if (!c || (!c.has_pets && !c.smoker && !c.dnar)) return null;
  return (
    <div className={detailed ? "flex flex-col gap-2" : "contents"} data-testid={`client-flags-${c.id}`}>
      {c.dnar && <span data-testid={`flag-dnar-${c.id}`} className={`${chip} bg-coral text-white`}><HeartOff size={11} /> DNAR{detailed && c.dnar_details ? ` — ${c.dnar_details}` : ""}</span>}
      {c.has_pets && <span data-testid={`flag-pets-${c.id}`} className={`${chip} bg-gold-light text-gold-dark`}><PawPrint size={11} /> Pets{c.pets_details ? `: ${c.pets_details}` : ""}</span>}
      {c.smoker && <span data-testid={`flag-smoker-${c.id}`} className={`${chip} bg-secondary text-ink-soft`}><Cigarette size={11} /> Smoker</span>}
    </div>
  );
}

export function ClientFlagsInputs({ form, set, input }) {
  const box = "flex items-center gap-2 rounded-lg border border-border px-3 py-2 text-sm text-ink";
  return (
    <div className="space-y-2 sm:col-span-2" data-testid="client-flags-inputs">
      <p className="text-sm font-medium text-ink">Home & safety tags</p>
      <div className="grid gap-2 sm:grid-cols-3">
        <label className={box}><input type="checkbox" className="accent-brand" checked={!!form.has_pets} onChange={(e) => set("has_pets", e.target.checked)} data-testid="client-has-pets" /> Has pets</label>
        <label className={box}><input type="checkbox" className="accent-brand" checked={!!form.smoker} onChange={(e) => set("smoker", e.target.checked)} data-testid="client-smoker" /> Smoker</label>
        <label className={box}><input type="checkbox" className="accent-brand" checked={!!form.dnar} onChange={(e) => set("dnar", e.target.checked)} data-testid="client-dnar" /> DNAR in place</label>
      </div>
      {form.has_pets && <input className={input} placeholder="Pets, e.g. small dog (friendly), cat" value={form.pets_details || ""} onChange={(e) => set("pets_details", e.target.value)} data-testid="client-pets-details" />}
      {form.dnar && <input className={input} placeholder="Where the DNAR form is kept, e.g. on the fridge" value={form.dnar_details || ""} onChange={(e) => set("dnar_details", e.target.value)} data-testid="client-dnar-details" />}
    </div>
  );
}
